import React from 'react';
import { Icon } from './Icon.js';
export const IconFolderImage = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M13 14H13.01", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M22 21H14V20L17.5 15H18.5L22 20V21Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13.4141 5H23V16.2021L21 13.3447V7H12.5859L9.58594 4H3V19H11V21H1V2H10.4141L13.4141 5Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconFolderImage.js.map